import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { apiClient } from "src/services/config/apiClient";
import { API } from "src/services/config/apiConfig";

import { StartFlowPayload, StartFlowResponse, StartUpdateFlowPayload } from "./NetTypes";

async function startUpdateFlowRequest({ id, token }: StartUpdateFlowPayload) {
	return await apiClient.post(API.COMMAND.LINK.UPDATE_FLOW(id, token)).then((res) => res.data);
}

export function useStartUpdateFlowRequest() {
	return useMutation<StartFlowResponse, AxiosError, StartUpdateFlowPayload>({
		mutationFn: (payload: StartUpdateFlowPayload) => startUpdateFlowRequest(payload)
	});
}

async function startFlowRequest({ id, entity, product, externalId, subproduct }: StartFlowPayload) {
	return await apiClient
		.post(
			API.COMMAND.LINK.START_FLOW,
			{ entity, product, externalId, subproduct },
			{ params: { id } }
		)
		.then((res) => res.data);
}

export function useStartFlowRequest() {
	return useMutation<StartFlowResponse, AxiosError, StartFlowPayload>({
		mutationFn: (payload: StartFlowPayload) => startFlowRequest(payload)
	});
}
